import { isExternalCoverageActive } from "@covertree/utils";
import { Coverage, CoverageDetails, PolicyType } from "@graphql/api";
import { CoverageFormDataWithTimestamps } from "@redux/coverages/types";
import { format } from "date-fns";

export function mapExternalPolicyDataToCoverage(
  data: CoverageFormDataWithTimestamps
): Coverage {
  const {
    isOtherInsuranceCarrier,
    otherInsuranceCarrierName,
    insuranceCarrierName,
    policyEffectiveDate,
    policyEndDate,
    description,
    withHomeDetails,
    homeType,
    modelYear,
    occupancyType,
    manufacturer,
    personalLiabilityLimit,
    homeCoverageLimit,
    otherStructuresLimit,
    personalPropertyLimit,
    standardDeductibleLimit,
    animalLiabilityLimit,
    medicalPaymentsLimit,
    ...rest
  } = data;

  return {
    id: "",
    ...rest,
    insuranceCarrierName: isOtherInsuranceCarrier
      ? otherInsuranceCarrierName
      : insuranceCarrierName.value,
    policyEffectiveDate: format(policyEffectiveDate, "yyyy-MM-dd"),
    policyEndDate: format(policyEndDate, "yyyy-MM-dd"),
    policyDescription: description,
    coverageDetails: withHomeDetails
      ? ({
          homeType,
          modelYear: modelYear ? +modelYear?.value : undefined,
          occupancy: occupancyType,
          manufacturer: manufacturer?.value,
          personalLiabilityLimit,
          homeCoverageLimit,
          otherStructuresLimit,
          personalPropertyLimit,
          standardDeductibleLimit,
          animalLiabilityLimit,
          medicalPaymentsLimit,
        } as unknown as CoverageDetails)
      : null,
    documents: [],
    isActive: isExternalCoverageActive(policyEffectiveDate, policyEndDate),
    policyType: PolicyType.External,
    updatedAt: new Date().getTime(),
    createdAt: new Date().getTime(),
  } as unknown as Coverage;
}
export default mapExternalPolicyDataToCoverage;
